module.exports = __webpack_public_path__ + "static/solo-exhibition-argentinian-embassy-berlin-9cd8b688c68c2e26cffde8077b9a998d.jpg";